import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { CheckboxFormControlComponent } from './checkbox-form-control.component';



@NgModule({
  declarations: [
    CheckboxFormControlComponent
  ],
  exports: [
    CheckboxFormControlComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatCheckboxModule
  ]
})
export class CheckboxFormControlModule { }
